export default __webpack_public_path__ + "static/media/ux-strategy-for-mobile-app-devlopment.5f7f048e.png";